// Keys of dynamic audit questions (dc0t). In SharePoint they are loaded at runtime.
// Keep as empty default to avoid runtime crashes when code checks `auditKeys.some(...)`.
export const auditKeys: string[] = [];

